import React from 'react';
import { cx } from 'linaria';

import * as Polymorphic from '../';
import { root } from './visually-hidden.styles';

export interface VisuallyHiddenOwnProps {
    /**
     *  Native HTML id attribute
     */
    id?: string;
    /**
     *  Test id for unit and e2e
     */
    testId?: string;
}

const DEFAULT_TAG = 'span';

export type VisuallyHiddenComponent = Polymorphic.ForwardRefComponent<typeof DEFAULT_TAG, VisuallyHiddenOwnProps>;

/**
 *
 *  Hides text visually but visible for the screenreaders to announce the text
 *
 *  _Example usecases_ - icon/image description, silent announcements, invisible input labels.
 *
 */
export const VisuallyHidden: VisuallyHiddenComponent = React.forwardRef((props, ref) => {
    const { as: Component = DEFAULT_TAG, children, id, testId, ...passThroughProps } = props;
    const className = cx(root, passThroughProps.className);

    return (
        <Component ref={ref} {...passThroughProps} id={id} data-testid={testId} className={className}>
            {children}
        </Component>
    );
});

VisuallyHidden.displayName = 'VisuallyHidden';
